const normalizeDetail = (value: unknown): string[] => {
  if (Array.isArray(value)) {
    return value.flatMap(normalizeDetail);
  }

  if (value && typeof value === "object") {
    return Object.entries(value as Record<string, unknown>).flatMap(
      ([field, detail]) => normalizeDetail(detail).map((message) => `${field}: ${message}`)
    );
  }

  if (value === null || typeof value === "undefined" || value === "") {
    return [];
  }

  return [String(value)];
};

export const getApiErrorMessage = (
  error: any,
  fallback = "No fue posible completar la operación."
) => {
  const data = error?.response?.data;
  const message =
    typeof data?.message === "string"
      ? data.message
      : typeof error?.message === "string"
        ? error.message
        : fallback;
  const details = normalizeDetail(data?.errors);

  return details.length > 0
    ? `${message}\n${details.join("\n")}`
    : message;
};

export const getFormErrorMessage = (
  errors: Record<string, any>,
  labels: Record<string, string> = {}
) => {
  const details = Object.entries(errors).flatMap(([field, error]) => {
    const label = labels[field] ?? field.replaceAll("_", " ");
    const messages = normalizeDetail(error?.message);
    return messages.length > 0
      ? messages.map((message) => `${label}: ${message}`)
      : [`${label}: información faltante o inválida`];
  });

  return details.length > 0
    ? `Revisa la información del formulario:\n${details.join("\n")}`
    : "Revisa los campos obligatorios y los formatos ingresados.";
};
